var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D0AC1FA0-ADFF-43EC-8195-557F624A294F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.7.0.1-Onboarding---Organisational-Chart---Full",
    transform: "translate(-24.000000, -343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-user",
    transform: "translate(0.000000, 319.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2298438,12.0426094 C16.7686406,11.823375 16.2980625,11.6345156 15.8192344,11.4763125 C17.37,10.3123125 18.375,8.45882813 18.375,6.375 C18.375,2.85984375 15.5152031,0 12,0 C8.48479688,0 5.625,2.85984375 5.625,6.375 C5.625,8.461125 6.63225,10.3164375 8.18592188,11.4802031 C6.76242188,11.9488594 5.42671875,12.6780938 4.25765625,13.6396875 C2.11396875,15.4029844 0.623484375,17.8624688 0.06084375,20.5651406 C-0.1155,21.4119844 0.095765625,22.2817969 0.640359375,22.9514531 C1.18228125,23.6178281 1.98585937,24 2.84498437,24 L14.390625,24 C14.9084063,24 15.328125,23.5802812 15.328125,23.0625 C15.328125,22.5447188 14.9084063,22.125 14.390625,22.125 L2.84498437,22.125 C2.44476562,22.125 2.2033125,21.9015937 2.09503125,21.7684688 C1.90804687,21.5385469 1.83567187,21.23925 1.89646875,20.9472656 C2.86935937,16.2740625 6.99135938,12.8603438 11.7514687,12.7452188 C11.8339219,12.7484063 11.91675,12.75 12,12.75 C12.0840469,12.75 12.1677187,12.7483594 12.2509688,12.745125 C13.7097187,12.7793438 15.1126875,13.11225 16.4249062,13.7360625 C16.8925781,13.95825 17.4517969,13.7594531 17.6740781,13.2917812 C17.8963594,12.8241562 17.6975156,12.2648906 17.2298438,12.0426094 Z M12.2286563,10.8692344 C12.1525781,10.867875 12.0763594,10.8671719 12,10.8671719 C11.9243438,10.8671719 11.8486875,10.8679219 11.773125,10.8693281 C9.39679687,10.7507812 7.5,8.78025 7.5,6.375 C7.5,3.89367187 9.51867187,1.875 12,1.875 C14.4813281,1.875 16.5,3.89367187 16.5,6.375 C16.5,8.77964062 14.6041406,10.7497969 12.2286563,10.8692344 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0625,18.609375 L20.484375,18.609375 L20.484375,16.03125 C20.484375,15.5134688 20.0646562,15.09375 19.546875,15.09375 C19.0290938,15.09375 18.609375,15.5134688 18.609375,16.03125 L18.609375,18.609375 L16.03125,18.609375 C15.5134688,18.609375 15.09375,19.0290938 15.09375,19.546875 C15.09375,20.0646562 15.5134688,20.484375 16.03125,20.484375 L18.609375,20.484375 L18.609375,23.0625 C18.609375,23.5802812 19.0290938,24 19.546875,24 C20.0646562,24 20.484375,23.5802812 20.484375,23.0625 L20.484375,20.484375 L23.0625,20.484375 C23.5802812,20.484375 24,20.0646562 24,19.546875 C24,19.0290938 23.5802812,18.609375 23.0625,18.609375 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/addUser.6a30ac0da7194fba04ba5aa43a41abfc.svg";